/**
 * @generated SignedSource<<df3d3fffef6633c4b31aa9b12f703354>>
 * @relayHash 0525d40f7cfda3a37d546a66a5d6aeaf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 290540599aaa3e6540fd1e4d0975d4ca5bc3f08f20c5a9708c47329ccf00bf9f

import type { ConcreteRequest } from 'relay-runtime';
export type collectionTrialModalQuery$variables = {
  collectionEntitlementId: string;
};
export type collectionTrialModalQuery$data = {
  readonly ccp: {
    readonly entitlementV2: {
      readonly experienceCapabilities: {
        readonly manageEntitlement: {
          readonly experienceUrl: string | null;
          readonly isAvailableToUser: boolean | null;
        } | null;
      } | null;
    } | null;
  } | null;
};
export type collectionTrialModalQuery = {
  response: collectionTrialModalQuery$data;
  variables: collectionTrialModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "collectionEntitlementId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "collectionEntitlementId"
  }
],
v2 = {
  "concreteType": "CcpEntitlementExperienceCapabilities",
  "kind": "LinkedField",
  "name": "experienceCapabilities",
  "plural": false,
  "selections": [
    {
      "concreteType": "CcpManageEntitlementExperienceCapability",
      "kind": "LinkedField",
      "name": "manageEntitlement",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "experienceUrl"
        },
        {
          "kind": "ScalarField",
          "name": "isAvailableToUser"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "collectionTrialModalQuery",
    "selections": [
      {
        "concreteType": "CcpQueryApi",
        "kind": "LinkedField",
        "name": "ccp",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "CcpEntitlement",
            "kind": "LinkedField",
            "name": "entitlementV2",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "collectionTrialModalQuery",
    "selections": [
      {
        "concreteType": "CcpQueryApi",
        "kind": "LinkedField",
        "name": "ccp",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "CcpEntitlement",
            "kind": "LinkedField",
            "name": "entitlementV2",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "290540599aaa3e6540fd1e4d0975d4ca5bc3f08f20c5a9708c47329ccf00bf9f",
    "metadata": {},
    "name": "collectionTrialModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "bf80f2370370843aff74887d5f300ea4";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
